import { SiteUrls } from '@tableau/shared-urls';
import { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import { WindowLocationService } from '~commonInfra/services/WindowLocationService';
import { Set } from '~commonInfra/utils/Set';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { DataAlertAddMe, DataAlertEdit, DataAlertRemoveMe, DataAlertResume } from '../../bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { DataAlertMenuAction } from '../actions/menuActions/DataAlertMenuActions';
import { IDataAlertInfo } from '../models/IDataAlertInfo';
import { DataAlerts } from '../resources/DataAlerts';
import { AddSelfToAlertsAction } from '../services/AddSelfToAlertsAction';
import { RemoveSelfFromAlertsAction } from '../services/RemoveSelfFromAlertsAction';

export function* handleAddMe(action: DataAlertMenuAction): SagaIterator {
  try {
    yield call(dataAlertAddMe, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function dataAlertAddMe(alerts: IDataAlertInfo[]) {
  return AddSelfToAlertsAction.addSelfToAlert(Set.fromIdItemArray(alerts));
}

export function* handleRemoveMe(action: DataAlertMenuAction): SagaIterator {
  try {
    yield call(dataAlertRemoveMe, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function dataAlertRemoveMe(alerts: IDataAlertInfo[]) {
  return RemoveSelfFromAlertsAction.removeSelfFromAlert(Set.fromIdItemArray(alerts));
}

export function* handleResume(action: DataAlertMenuAction): SagaIterator {
  try {
    yield call(dataAlertResume, action.items);

    const siteUrlName = yield select(SessionSiteSelectors.siteUrlName);
    directToVizWithAlert(siteUrlName, action.items[0]);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function dataAlertResume(alerts: IDataAlertInfo[]) {
  return DataAlerts.resumeAlerts(Set.fromIdItemArray(alerts).keys());
}

export function* handleEdit(action: DataAlertMenuAction): SagaIterator {
  try {

    const siteUrlName = yield select(SessionSiteSelectors.siteUrlName);
    directToVizWithAlert(siteUrlName, action.items[0]);

  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function directToVizWithAlert(siteUrlName: string, alert: IDataAlertInfo) {
  const siteUrls = new SiteUrls({siteUrlName});
  const url = DataAlerts.alertOnVizPath(alert, siteUrls);
  WindowLocationService.navigateTo(url);
}

export function* rootDataAlertMenuActionSaga(): SagaIterator {
  yield takeEvery(DataAlertAddMe, handleAddMe);
  yield takeEvery(DataAlertRemoveMe, handleRemoveMe);
  yield takeEvery(DataAlertResume, handleResume);
  yield takeEvery(DataAlertEdit, handleEdit);
}
